import { Modal } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { assetImagePath, assetSvgPath } from 'interfaces/constants'

import { StyledWorkshopHeading, StyledWorkshopTitle } from './index.styled'
import {
  StyledFinishButton,
  StyledPopupBody,
  StyledThankyouBanner,
  StyledThankyouDescription,
  StyledThankyouTitle,
} from './thankyou.styled'

type ThankyouPopupProps = {
  isOpen: boolean
  onClose: () => void
  isMobile: boolean
}
export const ThankyouPopup = ({ isOpen, onClose }: ThankyouPopupProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <Modal
      closeIcon={
        <img
          loading="lazy"
          src={`${assetImagePath}/close-icon.svg`}
          alt="close-btn"
        />
      }
      type="confirm"
      isOpen={isOpen}
      onClose={onClose}
    >
      <StyledWorkshopHeading>
        <StyledWorkshopTitle>
          {f({
            id: 'spotlight.landing.workshopForm.title',
            defaultMessage: 'Register to join the workshop',
          })}
        </StyledWorkshopTitle>
      </StyledWorkshopHeading>
      <StyledPopupBody>
        <StyledThankyouBanner src={`${assetSvgPath}/success-check.svg`} />
        <StyledThankyouTitle>
          {f({
            id: 'spotlight.landing.workshopForm.thankyou.title',
            defaultMessage: 'Thank you for registering the workshop',
          })}
        </StyledThankyouTitle>
        <StyledThankyouDescription>
          {f({
            id: 'spotlight.landing.workshopForm.thankyou.description',
            defaultMessage: 'Thank you for registering the workshop',
          })}
        </StyledThankyouDescription>
        <StyledFinishButton onClick={onClose}>
          {f({
            id: 'spotlight.landing.workshopForm.thankyou.finish',
            defaultMessage: 'Finish',
          })}
        </StyledFinishButton>
      </StyledPopupBody>
    </Modal>
  )
}
